import { create } from 'zustand'

/**
 * Runtime holder for RudderStack's anonymousId.
 *
 * Published by `useRudderstackAnalytics` once the SDK has loaded, so attribution
 * capture (`AttributionCapture`) can reuse the same stitch key as RudderStack's
 * events without instantiating a second RudderStack instance (which would
 * double-fire page-view tracking). Not persisted — RudderStack owns persistence.
 */
interface AnonymousIdStore {
  anonymousId: string | null
  setAnonymousId: (id: string) => void
}

const useAnonymousIdStore = create<AnonymousIdStore>((set) => ({
  anonymousId: null,
  setAnonymousId: (id) => set((state) => (state.anonymousId === id ? state : { anonymousId: id })),
}))

export default useAnonymousIdStore
